import React, { Component } from 'react';
import styled from 'styled-components';
import { Select } from '../shared/styled-components';
import Languages from '../../../../../server/scripts/helpers/languages';

const codesWithNames = Languages.getAllCodesWithNames();
const ItunesLanguagesOptions = Object.keys(codesWithNames).map((code, index) => {
  return <option value={code} key={index}>{codesWithNames[code]}</option>;
});

class ItunesLanguages extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.value === nextProps.value) {
      return false;
    }

    return true;
  }

  render() {
    const { value, onChange } = this.props;

    return (
      <InputSelect
        value={value}
        onChange={onChange}>
        {ItunesLanguagesOptions}
      </InputSelect>
    );
  }
}

const InputSelect = styled(Select)`
  font-size: 1.6rem;
  border-radius: 4px;
  margin-bottom: 0;
`;

export default ItunesLanguages;
